export default __webpack_public_path__ + "static/media/project8.4e25d194.jpg";